import { Divider, Grid, Typography } from '@mui/material'
import { useTranslate } from 'react-admin'
import { makeStyles } from 'tss-react/mui'

const deviderGridStyles = makeStyles()({
  root: {
    margin: 'auto',
  },
})

export const GridDevider = (props: any) => {
  const { variant = 'subtitle2', color = 'textSecondary', text = '🛥' } = props
  // tss-react returns { classes, cx, … }; MUI 9's Grid has no `classes` prop.
  const { classes } = deviderGridStyles()
  const translate = useTranslate()
  return (
    <>
      <Grid size={{ md: 5 }} className={classes.root}>
        <Divider variant='fullWidth' />
      </Grid>
      <Grid size={{ md: 2 }}>
        <Typography variant={variant} align='center' color={color}>
          {translate(text)}
        </Typography>
      </Grid>
      <Grid size={{ md: 5 }} className={classes.root}>
        <Divider variant='fullWidth' />
      </Grid>
    </>
  )
}
export default GridDevider
